import { ColumnDef } from '@tanstack/react-table';

import { AssignToCell, TotalAmountCell } from '@xemplo/amendments-table';
import { AmendmentListItem } from '@xemplo/gp-types';

/**
 * Read-only column set for the amendments summary panel. Reuses the shared
 * amendment cells so amount/worker rendering stays in parity with the main
 * amendments table.
 */
export const summaryColumns: ColumnDef<AmendmentListItem>[] = [
  {
    id: 'assignTo',
    accessorKey: 'assignTo',
    header: 'Worker',
    cell: AssignToCell,
    enableSorting: false,
  },
  {
    id: 'type',
    accessorKey: 'amendmentTaskTypeName',
    header: 'Type',
    enableSorting: false,
    cell: ({ row }) => {
      const { amendmentTaskTypeName, amendmentSubTypeName } = row.original;
      return (
        <span>
          {amendmentTaskTypeName || '-'}
          {amendmentSubTypeName && (
            <span className="amendment-sub-type"> · {amendmentSubTypeName}</span>
          )}
        </span>
      );
    },
  },
  {
    id: 'totalAmount',
    header: 'Total Amount',
    cell: TotalAmountCell,
    enableSorting: false,
  },
];
